import type {Translator} from '@logistics-frontend/core/i18n'
import type {Optional} from '@yandex-delivery/types'
import {add, firstOf, get, invert, max, merge, pipe, toDefaultZero} from '@yandex-delivery/utils'

import type {CargoReturnPointMP, Order, ReturnPoint, SourcePoint} from 'src/shared/types'

import {dropEmptyValues} from './drop-empty-values'
import {fromPointAddressToAddress} from './from-point-address'
import {fromPointContact} from './from-point-contact'
import {getOrderPointsIds} from './get-order-points-ids'

type ReturnOrSourcePoint = ReturnPoint | SourcePoint

export function fromSddExpressReturnPoint(t: Translator) {
  return function (order: Order): Optional<CargoReturnPointMP> {
    return pipe(
      order,
      firstOf<Order, ReturnOrSourcePoint>(get('returnPoint'), get('sourcePoint')),
      function _fromReturnPointField(point: Optional<ReturnOrSourcePoint>): CargoReturnPointMP {
        const contacts = pipe(order, get('sourcePoint'), fromPointContact(t))
        const returnPointContacts = merge(contacts, {
          phone: get('contact.phone', point),
        })

        return {
          visit_order: pipe(order, get('destinationPoints.length'), toDefaultZero, add(2)),
          contact: returnPointContacts,
          point_id: pipe(order, getOrderPointsIds, max, add(1)),
          address: pipe(point, get('address'), fromPointAddressToAddress, dropEmptyValues),
          type: 'return',
          skip_confirmation: pipe(order, get('isReturnPointCodeConfirmation'), invert),
        }
      },
    )
  }
}
